import styled from 'styled-components';

const NotificationsBox = styled.div`
  height: calc(100% - 72px);
  overflow-y: auto;
  padding-top: 10px;
`;

export { NotificationsBox };
